<template>
  <div id="first-content" class="col-12 col-sm-10 offset-sm-1 my-10">
    <section>
      <div class="first-content flex flex-vcenter justify-content-around m-auto">
        <v-img
          class="col-12 col-lg-4 offset-lg-1"
          height="75%"
          width="75%"
          src="https://api.quomi.it/oldimg/Quomi-kit-ricette-a-casa.webp"
				/>
        <div class="text-center col-12 col-lg-5">
          <h2 class="text-center">Un nuovo menù ogni settimana per tutti i gusti!</h2>
          <span class="description">
            Con i nostri <b>kit ricetta</b> fare la spesa è più facile, divertente e sostenibile. 
            Decidi cosa mangiare e ricevi a casa tutto il necessario già nelle giuste dosi. 
            <b>Ogni settimana tante nuove ricette a partire da 4,45€ a porzione</b> (più ordini e più risparmi!)
          </span>
        </div>
      </div>
    </section>

    <section>
      <div class="second-content flex flex-vcenter justify-content-around">
        <div class="text-center col-12 col-lg-5">
          <h2 class="text-center">Completa la tua spesa!</h2>
          <span class="description">
            Una <b>bottega</b> con una selezione di <b>prodotti <br/>artigianali e di qualità</b>. 
            <br>Pesce da allevamenti sostenibili, frutta e verdura senza OGM, carne senza aggiunta di ormoni o antibiotici. 
            <br> Direttamente <b>dal produttore alla tua tavola</b>.
          </span>
        </div>
        <v-img
          class="col-12 col-lg-4 mt-5"
          max-height="80%"
          max-width="80%"
          src="https://api.quomi.it/oldimg/Homepage2.png"
				/>
      </div>
    </section>

    <section>
      <div class="first-content flex flex-vcenter justify-content-around m-auto">
        <v-img
          class="col-12 col-lg-4 offset-lg-1 mt-5"
          max-height="80%"
          max-width="80%"
          src="https://api.quomi.it/oldimg/Homepage3_v2.png"
				/>
        <div class="text-center col-12 col-lg-5">
          <h2 class="text-center">Con l’abbonamento hai comodità e risparmio!</h2>
          <span class="description">
            Scegli l’opzione in abbonamento<br/> per <strong>ricevere ogni 7, 14 o 28 giorni</strong><br/>la tua spesa di ricette o cassette a casa senza costi aggiuntivi<br/>
            <strong>Nessun vincolo</strong>, ti sospendi con un click. In più avrai sempre la <strong>consegna gratuita!</strong>
          </span>
        </div>
      </div>
    </section>
  </div>
</template>

<script type="text/javascript">
	export default {

	}
</script>

<style scoped>
  p {
    font-size: 18px;
  }

  .description {
    font-size: 16px;
    line-height: 1.5;
  }

  @media (max-width: 1024px) {
    span{
      font-size: 14px;
    }
    .first-content{
      width: fit-content;
      flex-direction: column;
      margin-top: 20px;
    }
    .second-content {
      margin-top: 20px;
      flex-direction: column-reverse
    }

    #first-content {
      margin-top: 0 !important;
    }
  }

  @media (min-width: 768px) and (max-width: 1440px) {
    p{
      font-size: 15px;
      margin: 0 10px;
    }
  }
</style>